var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.is-concat-spreadable.js
// module id = 463
// module chunks = 3